<template>
  <RouterLink
    :to="completedHref"
    :target="target"
    aria-label="vicampo-link"
    @click="click"
  >
    <slot />
  </RouterLink>
</template>

<script>
const _createPath = (href) => {
  // The anchor-element parser needs a document; URL does the same job on the
  // server (VIP-12037)
  if (import.meta.env.SSR) {
    const url = new URL(href, 'https://ssr.invalid/')
    return url.pathname + url.hash + url.search
  }
  const l = document.createElement('a')
  l.href = href

  return l.pathname + l.hash + l.search
}
const DEFAULT_TARGET = '_self'

export default {
  components: {},
  props: {
    href: {
      type: String,
      required: true
    },
    target: {
      type: String,
      default: DEFAULT_TARGET,
      validator(target) {
        return ~['_self', '_blank', '_parent', '_top'].indexOf(target)
      }
    }
  },
  data() {
    return {
      completedHref: '/'
    }
  },
  methods: {
    isMetaClick({ ctrlKey, shiftKey, metaKey, button }) {
      return (
        ctrlKey || shiftKey || metaKey /* apple */ || button === 1
      ) /* middle click, >IE9 + everyone else */
    },
    async click(event) {
      const {
        HTML_EVENT: { CLICK }
      } = await import('@/constants/GlobalConstants')
      this.$emit(CLICK, event)

      if (this.isMetaClick(event)) {
        open(this.completedHref)
      }
    },

    async setLink(href) {
      if (!href) return

      this.completedHref = _createPath(href)
    }
  },
  created() {
    this.setLink(this.href)
  },
  watch: {
    href(href) {
      this.setLink(href)
    }
  }
}
</script>
